// Firestore rejects undefined anywhere in a payload. Chat messages carry agent data such as
// ARS candidate tables where optional fields (score, reason) are simply absent.
export function stripUndefinedDeep<T>(value: T): T {
  if (Array.isArray(value)) {
    return value.map(item => stripUndefinedDeep(item)) as unknown as T;
  }
  if (isPlainObject(value)) {
    const result: any = {};
    for (const [key, entry] of Object.entries(value as any)) {
      if (entry === undefined) continue;
      result[key] = stripUndefinedDeep(entry);
    }
    return result;
  }
  return value;
}

// Dates, Firestore Timestamps and other class instances must survive untouched.
function isPlainObject(value: any): boolean {
  return !!value && typeof value === 'object' && (value.constructor === Object || value.constructor === undefined);
}
